export function activeMenuPath(
  paths: (string | undefined)[],
  pathname: string,
) {
  return paths
    .filter((path): path is string =>
      Boolean(path && (pathname === path || pathname.startsWith(`${path}/`))),
    )
    .sort((a, b) => b.length - a.length)[0];
}
